import React from 'react';
import { motion } from 'framer-motion';
import { FaShieldAlt } from 'react-icons/fa';

interface AboutQualitySafetySectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  contentAr?: string;
  contentEn?: string;
  image?: string;
}

const AboutQualitySafetySection: React.FC<AboutQualitySafetySectionProps> = ({
  language = 'ar',
  titleAr = "سياسة الجودة والأمان",
  titleEn = "Quality & Safety Policy",
  contentAr = "الجودة والأمان هما أساس أعمالنا. نطبق أحدث نظم الجودة والسلامة ونعمل على تحسينها باستمرار لضمان أعلى مستويات الكفاءة وتحقيق متطلبات عملائنا، مع رقابة دورية وإجراءات دقيقة للفحص والمتابعة.",
  contentEn = "Quality and safety are the foundation of our work. We apply the latest quality and safety systems and continuously work to improve them to ensure the highest levels of efficiency and meet our clients' requirements, with periodic monitoring and precise procedures for inspection and follow-up.",
  image = "/images/image2.jpg"
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="section-padding bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="order-2 lg:order-1"
          >
            <img
              src={image}
              alt="Safety First"
              className="w-full h-64 object-cover rounded-xl shadow-lg"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2"
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mr-4">
                <FaShieldAlt className="w-6 h-6 text-white" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">{isRTL ? titleAr : titleEn}</h2>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              {isRTL ? contentAr : contentEn}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutQualitySafetySection; 